module.exports = __webpack_public_path__ + "static/media/blog-43-3.811bda39.webp";